import React from 'react'
import LeadGeneration from './LeadGeneration/LeadGeneration'
import RealState from './RealStatePeople/RealStatePeople'

function ExampleBoxes () {
  return (
    <section>
      <RealState />
      <LeadGeneration />
      {/* <GenericCasesPeople /> */}
    </section>
  )
}

export default ExampleBoxes
